import React, { memo } from 'react'
import { Button } from 'antd'
import { PhoneOutlined } from '@ant-design/icons'
import { CallStatusString } from 'src/types/ai-assistant'

interface CallActionAreaProps {
  callStatus: CallStatusString
  isCallMute: boolean
  isCallHold: boolean
  sessionId: string
  setIsCallMute: (isCallMute: boolean) => void
  setIsCallHold: (isCallHold: boolean) => void
}

const CallActionArea = memo(({ callStatus, isCallMute, isCallHold, sessionId, setIsCallMute, setIsCallHold }: CallActionAreaProps) => {
  return (
    <>
      <Button type="primary" danger shape="round" icon={<PhoneOutlined rotate={224} />} onClick={() => window.tccc.Call.hungUp({ sessionId })}>挂断</Button>
      {
        callStatus === 'talking' && (
          <>
            {
              isCallMute
                ? (
                  <Button type="primary" shape="round" onClick={() => {
                    window.tccc.Call.unmuteMic({ sessionId })
                    setIsCallMute(false)
                  }}>解除静音
                  </Button>
                )
                : (
                  <Button type="primary" shape="round" onClick={() => {
                    window.tccc.Call.muteMic({ sessionId })
                    setIsCallMute(true)
                  }}>静音
                  </Button>
                )
            }
            {isCallHold
              ? (
                <Button type="primary" disabled={isCallMute} shape="round" onClick={() => {
                  window.tccc.Call.unHold({ sessionId })
                  setIsCallHold(false)
                }}>恢复
                </Button>
              )
              : (
                <Button type="primary" disabled={isCallMute} shape="round" onClick={() => {
                  window.tccc.Call.hold({ sessionId })
                  setIsCallHold(true)
                }}>挂起
                </Button>
              )}
          </>
        )
      }
    </>
  )
})

export default CallActionArea
